import { DropdownItem } from '@eon-home/react-library';

import { SignUpRequestModelCountryEnum } from '@swagger-http';

import { Language } from '../enums';

export const COUNTRY_OPTIONS: DropdownItem[] = [
    {
        code: 'en', // locale
        text: 'United Kingdom',
        value: 'GB', // region
        iso: SignUpRequestModelCountryEnum.EnGb,
    },
    {
        code: 'de', // locale
        text: 'Deutschland',
        value: 'DE', // region
        iso: SignUpRequestModelCountryEnum.DeDe,
    },
    {
        code: 'it', // locale
        text: 'Italia',
        value: 'IT', // region
        iso: SignUpRequestModelCountryEnum.ItIt,
    },
    {
        code: 'hu', // locale
        text: 'Magyarország',
        value: 'HU', // region
        iso: SignUpRequestModelCountryEnum.HuHu,
    },
];

export const LANGUAGE_OPTIONS: DropdownItem[] = [
    {
        code: 'en',
        text: `🇬🇧  ${Language.ENGLISH}`,
        value: 'en',
        iso: SignUpRequestModelCountryEnum.EnGb,
    },
    {
        code: 'de',
        text: `🇩🇪  ${Language.GERMAN}`,
        value: 'de',
        iso: SignUpRequestModelCountryEnum.DeDe,
    },
    {
        code: 'it',
        text: `🇮🇹  ${Language.ITALIAN}`,
        value: 'it',
        iso: SignUpRequestModelCountryEnum.ItIt,
    },
    {
        code: 'hu',
        text: `🇭🇺  ${Language.HUNGARIAN}`,
        value: 'hu',
        iso: SignUpRequestModelCountryEnum.HuHu,
    },
];

// Time (in milliseconds) to wait before marking the user as idle
export const TIME_TO_IDLE = 1000 * 60 * 5; // The 5 minutes timeout was proposed by the P.O.

// Time (in milliseconds) to use in the Energy flow countdown when live data is still not available
export const LIVE_DATA_COUNTDOWN = 900000; // 15 minutes

// Time (in milliseconds) to use as an interval to fetch the current weather data
export const WEATHER_FETCH_INTERVAL = 900000; // 15 minutes

// Time (in milliseconds) to use as a timeout before opening an active accordion item
export const DEFAULT_ACCORDION_OPEN_TIME = 300;

// Time (in milliseconds) to use as a timeout when Emobility's state is Finishing
// Allows us to hide any intermediate states sent after the finishing state
export const EMOBILITY_FINISHING_TIME = 6000;

// Time (in milliseconds) to use as a timeout before reverting any state property
export const CLEANUP_TIME = 3000;

export const DataAnalysisConfig = {
    NEXT_TRIGGER_DELAY: 4,
};

export const GRIDX_ALTERNATIVE_BRANDING = 'E.ON Home Box';
